// extracted by mini-css-extract-plugin
export default {"videoPlayer":"videoPlayer__1bccG"};